export const layoutStyles = {
  contentWidth: "1000px",
  contentPadding: "0 1.0875rem 0",
}
